import TermsofService from "@/views/public/legal/TermsofService.vue";

export default {
  path: "/terms",
  name: "terms",
  component: TermsofService
};
